import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { MessageSquare } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import { GlowEffect } from '@/components/ui/glow-effect';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { SplineScene } from '@/components/ui/spline';
import AIConsultantChat from './AIConsultantChat';
const HeroSection = () => {
  const isMobile = useIsMobile();
  const [sheetOpen, setSheetOpen] = useState(false);
  const scrollToWhyChooseUs = () => {
    const whyChooseUsSection = document.getElementById('why-choose-us');
    if (whyChooseUsSection) {
      whyChooseUsSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-[90vh] bg-black flex items-center justify-center py-20">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-dark via-dark/90 to-dark/70 z-0"></div>
      
      {/* Animated background dots */}
      <div className="absolute inset-0 z-1 opacity-20">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }}></div>
      </div>
      
      {/* 3D Scene */}
      <div className="absolute inset-0 z-1">
        <SplineScene scene="https://prod.spline.design/kZDDjO5HuC9GJUM2/scene.splinecode" className="w-full h-full" />
      </div>
      
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-l from-transparent via-dark/70 to-dark/90 z-1"></div>
      
      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl pt-20">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 sm:mb-8 leading-tight font-display">
            <span className="text-gold">AI-Powered Development Studio:</span>
            <span className="text-white"> Build, Secure & Scale</span>
          </h1>
          
          <p className="text-base sm:text-lg md:text-xl text-white/80 mb-8 sm:mb-10 max-w-2xl mx-auto font-sans">
            From MVP development to WordPress automation and security audits—we're your end-to-end AI development partner under $5k
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-6">
            <Button starBorder size="lg" className="w-full sm:w-auto bg-gold hover:bg-gold/90 transition-all duration-300 font-cta z-10 relative" onClick={scrollToWhyChooseUs}>
              How We help you
            </Button>
            
            <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
              <SheetTrigger asChild>
                <Button variant="outline" size="lg" className="w-full sm:w-auto border-white/20 hover:bg-white/10 text-white font-cta">
                  <MessageSquare className="mr-2 h-4 w-4" />
                  Start Building
                </Button>
              </SheetTrigger>
              <SheetContent className="p-0 w-full sm:max-w-md md:max-w-lg">
                <AIConsultantChat fullPage />
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </section>;
};
export default HeroSection;